var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m63 18c0-1.654-1.346-3-3-3h-10v-2h4v-4c1.103 0 2-.897 2-2v-4c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2v2h-4v4h-8v-2h4v-4c1.103 0 2-.897 2-2v-4c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2v2h-4v4h-8v-2h4v-4c1.103 0 2-.897 2-2v-4c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2v2h-4v4h-8v-2h4v-4c1.103 0 2-.897 2-2v-4c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2v2h-4v4h-8v-2h4v-4c1.103 0 2-.897 2-2v-4c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2v2h-4v4h-4c-1.654 0-3 1.346-3 3v11h3c1.654 0 3 1.346 3 3s-1.346 3-3 3h-3v11c0 1.654 1.346 3 3 3h10v2h-4v4c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-4c0-1.103-.897-2-2-2v-2h4v-4h8v2h-4v4c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-4c0-1.103-.897-2-2-2v-2h4v-4h8v2h-4v4c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-4c0-1.103-.897-2-2-2v-2h4v-4h8v2h-4v4c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-4c0-1.103-.897-2-2-2v-2h4v-4h8v2h-4v4c-1.103 0-2 .897-2 2v4c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-4c0-1.103-.897-2-2-2v-2h4v-4h4c1.654 0 3-1.346 3-3v-11h-3c-1.654 0-3-1.346-3-3s1.346-3 3-3h3zm-11-15h2l.001 4h-2.001zm-10 0h2l.001 4h-2.001zm-10 0h2l.001 4h-2.001zm-10 0h2l.001 4h-2.001zm-10 0h2l.001 4h-2.001zm0 58h-2l-.001-4h.001 2zm10 0h-2l-.001-4h.001 2zm10 0h-2l-.001-4h.001 2zm10 0h-2l-.001-4h.001 2zm10 0h-2l-.001-4h.001 2zm-1-44v30h-38v-30zm-48 29v-9h1c2.757 0 5-2.243 5-5s-2.243-5-5-5h-1v-9c0-.551.449-1 1-1h7v30h-7c-.551 0-1-.449-1-1zm58-19h-1c-2.757 0-5 2.243-5 5s2.243 5 5 5h1v9c0 .551-.449 1-1 1h-7v-30h7c.551 0 1 .449 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59 31h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 31h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45 19h-26v26h26zm-2 6h-2v-2h-2v-2h4zm-2 10h2v2h-2zm0-2v-2h2v2zm0-4v-2h2v2zm-12 12v2h-2v-2zm2 0h2v2h-2zm4 0h2v2h-2zm-10-2v-14h14v14zm8-16h-2v-2h2zm2-2h2v2h-2zm-6 2h-2v-2h2zm-4-2v2h-2v2h-2v-4zm-2 16h-2v-2h2zm0-4h-2v-2h2zm0-4h-2v-2h2zm-2 10h2v2h2v2h-4zm18 4v-2h2v-2h2v4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 27c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5-2.243-5-5-5zm0 8c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 23h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 19h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 27h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 39h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 35h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 43h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 19h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 43h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 43h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 19h2v2h-2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.83497cfb395a6bc5516cc3dfc48d56c8.svg";
export { ForwardRef as ReactComponent };